<p-tabs [value]="activeTabIndex">
  <p-tablist>
    <p-tab [value]="TabIndex.LISTA" (click)="onTabChange(TabIndex.LISTA)" [disabled]="false">
      <i class="pi pi-align-left"></i>
      <span>{{ getTabName(TabIndex.LISTA) }}</span>
    </p-tab>
    <p-tab [value]="TabIndex.BODY" (click)="onTabChange(TabIndex.BODY)" [disabled]="tabsDisabled[TabIndex.BODY]">
      <i class="pi pi-align-left"></i>
      <span>{{ getTabName(TabIndex.BODY) }}</span>
    </p-tab>
    <p-tab [value]="TabIndex.PREVIEW" (click)="onTabChange(TabIndex.PREVIEW)"
      [disabled]="tabsDisabled[TabIndex.PREVIEW]">
      <i class="pi pi-eye"></i>
      <span>{{ getTabName(TabIndex.PREVIEW) }}</span>
    </p-tab>
    <p-tab [value]="TabIndex.FILES" (click)="onTabChange(TabIndex.FILES)" [disabled]="tabsDisabled[TabIndex.FILES]">
      <i class="pi pi-paperclip"></i>
      <span>{{ getTabName(TabIndex.FILES) }}</span>
    </p-tab>
  </p-tablist>

  <p-tabpanel [value]="TabIndex.LISTA">
    <div class="tab-content">
      <div class="w-full bg-white mb-2 shadow-sm px-4 flex items-center justify-between">
        <p class="text-xl sm:text-2xl md:text-3xl lg:text-6xl xl:text-8xl text-gray-800">
          <!-- font-serif font-bold text-gray-800 tracking-tight leading-tight mb-0 italic font-light -->
          <i class="icon-zoomin2 text-gray-600 text-[1.3em]"></i> - Seccion de
          Lista
        </p>
        <p-button label="Nuevo" icon="pi pi-cog" variant="outlined" (onClick)="newMail()"></p-button>
      </div>
      <app-inbox [table]="tableSubject$ | async" [data]="dataSubject$ | async" (onConsult)="onLoadRecordss($event, 1)"
        (onLazyLoad)="onLoadRecordss($event, 2)">
      </app-inbox>
    </div>
  </p-tabpanel>

  <p-tabpanel [value]="TabIndex.BODY">
    <div class="tab-content">
      <!-- <h3 class="section-title">CUERPO DEL CORREO ELECTRÓNICO</h3> -->

      <!-- Form -->
      <form [formGroup]="emailForm" (ngSubmit)="onSubmit()">
        <!-- First Row: From, Subject, To -->
        <div class="form-grid">
          <!-- From Field -->
          <div class="form-field">
            <label for="from" class="field-label">
              From <span class="required-asterisk">*</span>
            </label>
            <input id="from" type="email" pInputText formControlName="Mil_From"
              placeholder="erpnotificaciones@arealimpia.com.co" [class.ng-invalid]="isFieldInvalid('Mil_From')"
              class="form-input" />
            @if (isFieldInvalid('Mil_From')) {
            <small class="error-message">
              {{ getFieldError("Mil_From") }}
            </small>
            }
          </div>

          <!-- Subject Field -->
          <div class="form-field">
            <label for="subject" class="field-label">
              Subject <span class="required-asterisk">*</span>
            </label>
            <input id="subject" type="text" pInputText formControlName="Mil_Subject"
              placeholder="Envío Orden de Compra No19446" [class.ng-invalid]="isFieldInvalid('Mil_Subject')"
              class="form-input" />
            @if (isFieldInvalid('Mil_Subject')) {
            <small class="error-message">
              {{ getFieldError("Mil_Subject") }}
            </small>
            }
          </div>

          <!-- To Field -->
          <div class="form-field">
            <label for="to" class="field-label">
              To <span class="required-asterisk">*</span>
            </label>
            <div class="to-field-container">
              <input id="to" type="email" pInputText formControlName="Mil_To" placeholder="carlos.vargas@syspotec.com"
                [class.ng-invalid]="isFieldInvalid('Mil_To')" class="form-input to-input" />
              <p-button type="button" label="CC-CCO" (click)="toggleCcField()" class="p-button-sm cc-button"></p-button>
            </div>
            @if (isFieldInvalid('Mil_To')) {
            <small class="error-message">
              {{ getFieldError("Mil_To") }}
            </small>
            }
          </div>
        </div>

        <!-- Second Row: CC Field (Full Width) -->
        @if (showCcField) {
        <div class="form-row">
          <div class="form-field full-width">
            <label for="cc" class="field-label"> CC (Copia) </label>
            <input id="cc" type="email" pInputText formControlName="Mil_CC"
              placeholder="ejemplo@correo.com, otro@correo.com" [class.ng-invalid]="isFieldInvalid('Mil_CC')"
              class="form-input" />
            @if (isFieldInvalid('Mil_CC')) {
            <small class="error-message">
              {{ getFieldError("Mil_CC") }}
            </small>
            }
            <small class="field-help">
              Separar múltiples correos con comas
            </small>
          </div>
        </div>
        }

        <!-- Body Field -->
        <div class="body-field">
          <label for="body" class="field-label">
            Body <span class="required-asterisk">*</span>
          </label>
          <!-- <p-editor formControlName="Mil_Body" [style]="{ height: '300px' }"
            [class.ng-invalid]="isFieldInvalid('Mil_Body')"
            placeholder="Por medio de la presente se envía orden de compra No: 19446...">
          </p-editor> -->
          <editor [init]="init" formControlName="Mil_Body" (onInit)="onTinyMCEInit($event)"></editor>
          @if (isFieldInvalid('Mil_Body')) {
          <small class="error-message">
            {{ getFieldError("Mil_Body") }}
          </small>
          }
        </div>
        <!-- Modal lanzado por TinyMCE con CodeMirror v6 embebido -->
        <p-dialog [(visible)]="showModal" modal="true" header="Editor de código HTML" [style]="{ width: '700px' }">
          <div class="space-y-4 p-4 bg-white rounded-lg shadow-md">
            <div id="codemirror-editor" class="w-full h-60 text-sm"></div>

            <div class="text-right">
              <button id="apply-btn" type="button"
                class="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-md transition">
                Aplicar
              </button>
              <button class="bg-gray-600 hover:bg-gray-700 text-white px-5 py-2 rounded-md transition ml-2"
                (click)="showModal = false">
                Cancelar
              </button>
            </div>
          </div>
        </p-dialog>


        <div>
          <app-lupas formControlName="Msy_Mtm_CodMailTemplates" [dataSearhLupa]="dataSearhLupaCampo1"></app-lupas>
        </div>
      </form>

      <!-- Form Status Display (for development) -->
      <!-- <div class="form-debug" *ngIf="showDebugInfo">
          <h4>Estado del Formulario:</h4>
          <p><strong>Válido:</strong> {{ emailForm.valid }}</p>
          <p><strong>Tab Activo:</strong> {{ getActiveTabName() }} ({{ activeTabIndex }})</p>
          <p><strong>Valores:</strong></p>
          <pre>{{ emailForm.value | json }}</pre>
        </div> -->
    </div>
  </p-tabpanel>

  <p-tabpanel [value]="TabIndex.PREVIEW">
    <div class="tab-content">
      <!-- <app-renderizar-html></app-renderizar-html> -->
      @defer (on viewport; prefetch on hover) {
      <app-renderizar-html [htmlContent]="renderHtmlMail">
      </app-renderizar-html>
      } @placeholder {
      <div class="placeholder">Cargando vista previa...</div>
      } @loading {
      <div class="loading-spinner">
        <p-progressSpinner></p-progressSpinner>
      </div>
      }
    </div>
  </p-tabpanel>

  <p-tabpanel [value]="TabIndex.FILES">
    <div class="tab-content">
      @if (showTabFiles) {
      <app-file-upload [documentTypeOptions]="documentTypeOptions" (filesSelected)="onSelectedFiles($event)"
        (uploadComplete)="onUpload($event)" (uploadError)="uploadError($event)">
      </app-file-upload>

      <app-table-generic [table]="tableService.tableSubject"
        [data]="(tableService.dataTableGenericSubject$ | async)?.data ?? []" [totalRecords]="tableService.totalRecords"
        (onLazyLoad)="tableService.onLoadRecords($event)">
      </app-table-generic>
      }
    </div>
  </p-tabpanel>
</p-tabs>

<!-- Footer -->
<!-- <div class="mail-footer">
    <div class="footer-left">
      <span class="powered-by">POWERED BY TINY</span>
    </div>
    <div class="footer-right">
      <button pButton type="button" icon="pi pi-sign-out" label="Salir" class="p-button-outlined p-button-sm">
      </button>
    </div>
  </div> -->
<p-toast></p-toast>